import { ABOUT_CTA, ABOUT_SEO } from '@/data/about';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { AboutHero } from '@/components/site/about/AboutHero';
import { OurStory } from '@/components/site/about/OurStory';
import { Founders } from '@/components/site/about/Founders';
import { Timeline } from '@/components/site/about/Timeline';
import { WhatWeDo } from '@/components/site/about/WhatWeDo';
import { OurApproach } from '@/components/site/about/OurApproach';
import { CtaBand } from '@/components/site/CtaBand';

export default function AboutPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: ABOUT_SEO.title,
    description: ABOUT_SEO.description,
    canonical: `${origin}/about`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${origin}/` },
        { '@type': 'ListItem', position: 2, name: 'About', item: `${origin}/about` },
      ],
    },
  });

  return (
    <>
      <AboutHero />
      <OurStory />
      <Founders />
      <Timeline />
      <WhatWeDo />
      <OurApproach />
      <CtaBand
        eyebrow={ABOUT_CTA.eyebrow}
        heading={ABOUT_CTA.heading}
        copy={ABOUT_CTA.copy}
        primaryLabel={ABOUT_CTA.primaryLabel}
        secondaryLabel={ABOUT_CTA.secondaryLabel}
        secondaryHref={ABOUT_CTA.secondaryHref}
      />
    </>
  );
}
